/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Active_LabelInputs */



/**
* | output |
* | --- |
* | "Active" |
*
* @param {Promo_Active_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_active_label = /** @type {((inputs?: Promo_Active_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Active_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Active")
	if (locale === "es") return /** @type {LocalizedString} */ ("Activa")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Ativa")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva")
	return /** @type {LocalizedString} */ ("Active")
});